// Placeholders a pending region shows in the shape of what it will hold, so
// nothing moves when the data lands. They are decoration: the region they sit
// in carries aria-busy, and a screen reader hears the `label` instead.
// Modelled on FindingsConsole's RowsLoading.

const BAR = "block h-[9px] animate-pulse rounded-[2px] bg-[color:var(--line-soft)] motion-reduce:animate-none";

/** One pulsing bar. `className` sets its width (and height, if not 9px). */
export function SkeletonBar({ className = "" }) {
    return <span aria-hidden="true" className={`${BAR} ${className}`} />;
}

/**
 * `rows` placeholder rows, each `rowClassName` (give it the real row's grid
 * and height), fading down the list. `cells` is how many bars a row holds,
 * or a list of each bar's width class.
 */
export function SkeletonRows({ rows = 6, cells = 3, rowClassName = "grid h-[40px] grid-cols-3 items-center gap-[16px]", label = "Loading…" }) {
    const widths = Array.isArray(cells) ? cells : Array.from({ length: cells }, (_, i) => (i ? "w-[60%]" : "w-[80%]"));
    return (
        <div data-skeleton-rows="">
            <span className="sr-only">{label}</span>
            <div aria-hidden="true">
                {Array.from({ length: rows }, (_, i) => (
                    <div key={i} className={`${rowClassName} border-b border-[color:var(--line-soft)]`} style={{ opacity: Math.max(0.25, 1 - i * 0.12) }}>
                        {widths.map((w, j) => <SkeletonBar key={j} className={w} />)}
                    </div>
                ))}
            </div>
        </div>
    );
}

/** A few lines of text-shaped bars, for a paragraph or a short list. */
export function SkeletonLines({ lines = 3, label = "Loading…" }) {
    const widths = ["w-[72%]", "w-[54%]", "w-[64%]", "w-[40%]", "w-[58%]"];
    return (
        <div className="grid gap-[10px] py-[4px]" data-skeleton-lines="">
            <span className="sr-only">{label}</span>
            {Array.from({ length: lines }, (_, i) => <SkeletonBar key={i} className={widths[i % widths.length]} />)}
        </div>
    );
}
